function getDeviceInfo() {
    return {
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        touchPoints: window.navigator.maxTouchPoints,
        pixelratio: window.devicePixelRatio,
        mouseSupport: matchMedia('(pointer:fine)').matches,
        mobileFlag: navigator.userAgentData && navigator.userAgentData.mobile,
    };
}
export function sendErrorTrace(_a) {
    var error = _a.error, data = _a.data;
    return fetch('/gd/rest/jslog/error', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            device: getDeviceInfo(),
            name: error.name,
            message: error.message,
            stack: error.stack,
            url: document.location.href,
            data: data,
        }),
    });
}
export function sendTrace(_a) {
    var name = _a.name, data = _a.data;
    return fetch('/gd/rest/jslog/log', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            device: getDeviceInfo(),
            name: name,
            url: document.location.href,
            data: data,
        }),
    });
}
//# sourceMappingURL=sendTrace.js.map